export interface ScrollIndicatorInterface {
	wrapper: HTMLElement;
	threshold: number;
}

export const ScrollIndicator = {
	position: window.pageYOffset as number,
	quickActions: [] as HTMLElement[],
	contentElements: [] as HTMLElement[],
	threshold: 0,
	ticking: false,
	wrapper: document.documentElement as HTMLElement,

	init(config?: ScrollIndicatorInterface): void {
		if (config?.threshold !== undefined) {
			this.threshold = config.threshold;
		}

		this.quickActions = Array.from(
			document.querySelectorAll('[data-quick-action]')
		) as HTMLElement[];

		this.bindEvents();
		this.eventListener();
		this.setIndicator('scroll--has-indicator');
	},

	bindEvents(): void {
		window.addEventListener('load', () => this.eventListener());
		window.addEventListener('resize', () => this.eventListener());

		window.addEventListener('scroll', () => {
			if (!this.ticking) {
				requestAnimationFrame(() => {
					this.eventListener();
					this.ticking = false;
				});
				this.ticking = true;
			}
		});
	},

	eventListener(): void {
		const offset: number = window.pageYOffset;

		this.handleTopIndicator(offset);
		this.handleUpIndicator(offset);
		this.handleDownIndicator(offset);
		this.handleBottomIndicator(offset);

		this.position = offset;
	},

	handleBottomIndicator(position: number): void {
		const windowHeight: number = window.innerHeight;
		const docHeight: number = document.documentElement.scrollHeight;
		const isAtBottom: boolean = (windowHeight + position) >= (docHeight - this.threshold);

		this.toggleIndicator('scroll--position-bottom', isAtBottom)
	},

	handleDownIndicator(position: number): void {
		const scrollDown: boolean = position > this.position;

		this.toggleIndicator('scroll--direction-down', scrollDown);
	},

	handleTopIndicator(position: number): void {
		const isAtTop: boolean = position <= this.threshold;

		this.toggleIndicator('scroll--position-top', isAtTop);
	},

	handleUpIndicator(position: number): void {
		const scrollUp: boolean = position < this.position;

		this.toggleIndicator('scroll--direction-up', scrollUp);
	},

	removeIndicator(className: string): void {
		this.wrapper.classList.remove(className);
	},

	setIndicator(className: string): void {
		this.wrapper.classList.add(className);
	},

	toggleIndicator(className: string, condition: boolean): void {
		this.wrapper.classList.toggle(className, condition);
	}

};
